export const isClient = (): boolean => typeof window !== 'undefined';
export const cookiesEnabled = isClient() ? navigator.cookieEnabled : false;
